import React from 'react';
import { motion } from 'framer-motion';
import { BRAND_PHILOSOPHY } from '../../data/brandData';

export function BrandIntro() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Nuestra historia - 我们的历史 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nuestra historia
            </h2>
            <div className="w-20 h-1 bg-black mx-auto"></div>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* 左侧：简化的文字内容 */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                En ZWheel, transformamos la movilidad urbana desde Barcelona.
                Diseñamos patinetes eléctricos que son más que transporte:
                son compañeros de vida.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                {BRAND_PHILOSOPHY.description}
              </p>
            </motion.div>

            {/* 右侧：关键数据展示 */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="grid grid-cols-2 gap-6"
            >
              <div className="bg-gray-50 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-black mb-2">2019</div>
                <div className="text-sm text-gray-600">Año de fundación</div>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-black mb-2">100K+</div>
                <div className="text-sm text-gray-600">Usuarios activos</div>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-black mb-2">5</div>
                <div className="text-sm text-gray-600">Series de productos</div>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-black mb-2">14</div>
                <div className="text-sm text-gray-600">Modelos disponibles</div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
